import { useAccount } from './useAccount'
import { useZocksQuota } from '../components/ScopedBlock/hooks'

export const usePrivateMeetingsEnabled = () => {
  const { account } = useAccount({ refetchOnMountOrArgChange: false })
  const { hasQuota } = useZocksQuota()
  const privateMeetingsQuota = hasQuota('identity.privateMeetingsEnabled.value')
  const privateMeetingsSetting = !!(account && account.effectiveConfig.privateMeetings)
  const privateMeetingsEnabled = privateMeetingsQuota && privateMeetingsSetting
  return { privateMeetingsEnabled, privateMeetingsQuota, privateMeetingsSetting }
}
